import Tooltip from "../../UI/Tooltip";
import Status from "../../UI/Status";
import Text from "../../UI/Text";
// @ts-expect-error pure js
import { currencyFormatter } from "../../../api/Functions";
import type { Tenant } from "../../../models/tenant";

export default function AplTag({ tenant }: { tenant: Tenant }) {
  if (!tenant.caf_aide) {
    return null;
  }

  const tooltipContent = (
    <>
      <Text>
        <Text as="strong" weight="bold">
          Aide au logement :
        </Text>{" "}
        {tenant.montant_caf
          ? currencyFormatter(tenant.montant_caf)
          : "montant non renseigné"}
      </Text>
      <Text>
        <Text as="strong" weight="bold">
          N° allocataire :
        </Text>{" "}
        {tenant.caf_numero_allocataire || "non renseigné"}
      </Text>
    </>
  );

  return (
    <Tooltip content={tooltipContent}>
      <Status color="success" text="APL" />
    </Tooltip>
  );
}
